export var APPEAR_TRANSITION_DURATION = 180;
export var APPEAR_TRANSITION_POSITIONS = [].concat(['auto', 'top', 'bottom', 'left', 'right'].reduce(function (acc, p) {
  return [].concat(acc, [p, p + "-start", p + "-end"]);
}, []));
export var APPEAR_TRANSITION_TYPES = ['slide', 'zoom'];